import { useEffect, useState } from "react";
import { PageHero, Container } from "../components/Section";
import { api, API } from "../lib/api";
import { Play } from "lucide-react";
import { motion } from "framer-motion";

export default function ServicesArchive() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/media?category=services").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="services-archive-page">
      <PageHero
        overline="Services Archive"
        title={<>Every <em className="text-gold-light italic font-light">Sunday</em>, on demand.</>}
        kicker="Re-watch a sermon, share it with a friend, or catch up on a service you missed."
        image="/images/branding/pastor-worship.jpg"
      />

      <Container className="pb-32">
        {items.length === 0 ? (
          <div className="text-center py-20 glass">
            <p className="font-serif italic text-white/60 text-lg">Service videos coming soon. Admin can upload via the admin panel.</p>
          </div>
        ) : (
          <div className="space-y-px bg-white/5">
            {items.map((m, i) => (
              <motion.div
                key={m.id}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: (i % 8) * 0.03 }}
                className="bg-wine-950 hover:bg-wine-900 transition-colors p-8 grid md:grid-cols-12 gap-6 items-center group"
                data-testid={`service-${m.id}`}
              >
                <div className="md:col-span-1">
                  <div className="w-12 h-12 rounded-full bg-wine-700 group-hover:bg-gold flex items-center justify-center transition-colors">
                    <Play className="h-5 w-5" />
                  </div>
                </div>
                <div className="md:col-span-7">
                  <h3 className="font-serif text-2xl font-bold mb-1">{m.title}</h3>
                  {m.series && <div className="text-xs uppercase tracking-widest text-gold/70 mb-2">{m.series}</div>}
                  {m.description && <p className="text-white/65 text-sm line-clamp-2">{m.description}</p>}
                </div>
                <div className="md:col-span-2 text-sm text-white/55">{m.speaker}</div>
                <div className="md:col-span-2 text-right">
                  <a href={`${API}/media/file/${m.id}`} target="_blank" rel="noopener noreferrer" className="btn-ghost inline-block px-5 py-2 rounded-full text-xs uppercase tracking-widest">Watch</a>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
}
